import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import uiReducer from "./slices/uiSlice";
import jobReducer from "./slices/jobSlice";
import masterDataReducer from "./slices/masterDataSlice";
import languageSlice from "./slices/languageSlice";

export default configureStore({
    reducer: {
        user: userReducer,
        ui: uiReducer,
        job: jobReducer,
        master_data: masterDataReducer,
        language: languageSlice,
    },
    devTools: process.env.NODE_ENV === "development" ? true : false
})